module.exports = __webpack_public_path__ + "img/a4.8dbbe0b9.jpg";